import React from "react";
import WorkScene from "../components/WorkScene";
import WorkGrid from "../components/WorkGrid";

const Work = () => {
  return (
    <>
      <WorkScene />
      <WorkGrid />
    </>
  );
};

export default Work;
